(ns teamoesterreich.web-path
  (:require
    [goog.events])
  (:import
    (goog.history EventType Html5History)))

(def title "")

(defn set-title [t]
  (def title t))


;;;;;  https://lispcast.com/mastering-client-side-routing-with-secretary-and-goog-history/

(defn get-token []
  (str js/window.location.pathname js/window.location.hash))

(defn make-history []
  (doto (Html5History.)
    (.setPathPrefix (str js/window.location.protocol "//" js/window.location.host))
    (.setUseFragment true)))


(defn handle-url-change [e page-change-action-fn]
  ;; log the event object to console for inspection
  (js/console.log "handle-url-change " (get-token))
  (if (.-isNavigation e)
    (do (js/console.log "Token set url" (get-token) e)
        (page-change-action-fn (.replace (get-token) "/" "")))

    (do (js/console.log "Token set programmatically" (get-token))
        (page-change-action-fn (.replace (get-token) "/" "")))
    )
  )

(defn register [page-change-action-fn]
  (def page-change-action-fn page-change-action-fn)
  (defonce history (doto (make-history)
                     (goog.events/listen EventType.NAVIGATE #(handle-url-change % page-change-action-fn))
                     (.setEnabled true))))

(defn nav! [token]
  (js/console.log "nav!  -> " token)
  (when history
    (js/console.log "nav!: " (.getToken history) "  -> " token)
    (set! (. js/document -title) (str title " | " token))
    (.setToken history token)))

(defn call-page-change-action-fn [token]
  (when page-change-action-fn (page-change-action-fn token)))

(defn load [] (call-page-change-action-fn (get-token)))

;
;goog.history.Event {type: "navigate", target: g…g.h…y.Html5History, currentTarget: g…g.h…y.Html5History, propagationStopped_: false, defaultPrevented: false, …}
;currentTarget: goog.history.Html5History {disposed_: false, onDisposeCallbacks_: undefined, eventTargetListeners_: g…g.e…s.ListenerMap, actualEventTarget_: g…g.h…y.Html5History, parentEventTarget_: null, …}
;defaultPrevented: false
;isNavigation: false
;propagationStopped_: false
;returnValue_: true
;target: goog.history.Html5History {disposed_: false, onDisposeCallbacks_: undefined, eventTargetListeners_: g…g.e…s.ListenerMap, actualEventTarget_: g…g.h…y.Html5History, parentEventTarget_: null, …}
;token: "neighbor"
;type: "navigate"
;__proto__: goog.events.Event